/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Agent_Team_DescInputs */

const en_mk_nav_agent_team_desc = /** @type {(inputs: Mk_Nav_Agent_Team_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parallel work, your API key, or an agent subscription login.`)
};

const id_mk_nav_agent_team_desc = /** @type {(inputs: Mk_Nav_Agent_Team_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerja paralel, API key sendiri, atau login langganan agent.`)
};

/**
* | output |
* | --- |
* | "Parallel work, your API key, or an agent subscription login." |
*
* @param {Mk_Nav_Agent_Team_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_agent_team_desc = /** @type {((inputs?: Mk_Nav_Agent_Team_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Agent_Team_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_agent_team_desc(inputs)
	return en_mk_nav_agent_team_desc(inputs)
});